
import Article from "./Article.vue"
import AppButton from "./AppButton"
import buttonProps from "../helpers/buttonProps"

export default {
  components: {
    Article,
    AppButton
  },
  props: {
    article: {
      type: Array,
      default: () => []
    },
    rightCardTitle: {
      type: String,
      default: null
    },
    rightCardText: {
      type: String,
      default: null
    },
    leftCardTitle: {
      type: String,
      default: null
    },
    leftCardText: {
      type: String,
      default: null
    },
    button: {
      type: Array,
      default: () => []
    },
    backgroundColor: {
      type: String,
      default: null
    },
    badge: {
      type: String,
      default: null
    }
  },
  computed: {
    buttonProps() {
      return buttonProps(this.button)
    }
  }
}
